<template>
  <div class="pr-0">
    <v-row no-gutters>
      <v-col class="ml-4 font18 bold headline1">บทความทั้งหมด</v-col>
    </v-row>
     <v-card
        class="mx-auto rounded-lg ml-2 mr-2"
        v-if="!items"
        elevation="2"
        height="100%"
      >
         <v-skeleton-loader height="100vh"
          type="list-item-three-line, image, article,list-item-three-line, image"
        ></v-skeleton-loader>
      </v-card>
    <v-card
      v-for="(item, i) in items"
      :key="i"
      class="ml-4 mr-4 mb-10 mt-4"
      width="93%"
    >
    <v-card-text>
      <v-row>
        <v-col class="col-5 pt-0">
          <v-img
            :src="item.blogPicture"
            height="114"
            class="link"
            @click="$router.push(`/blog/detail/${item.id}`)"
          >
          </v-img>
        </v-col>
        <v-col class="col-7">
          <v-row class="font16 bold">
            <v-col class="pl-0 pt-2 pb-3">{{ item.blogName }}</v-col>
          </v-row>
          <v-row class="font14">
            <v-col class="pl-0 pt-0 pb-3">{{ item.blogSubName }} </v-col>
          </v-row>
          <v-row class="font14 icon2">
            <v-col class="pt-1 text-end pr-6">
              <v-btn
                outlined
                rounded
                x-small
                class="headline1"
                @click="checkLinkOrBlog(item)"
                >เข้าชมรายละเอียด
                </v-btn
              >
            </v-col>
          </v-row>
        </v-col>
      </v-row>
          </v-card-text>
    </v-card>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
  name: 'AllBlog',
  data () {
    return {
      items: null,
      session: this.$session.getAll(),
      member: null,
      profile: null
    }
  },
  // eslint-disable-next-line space-before-function-paren
  async mounted() {
    window.scrollTo(0, 0)
    this.member = this.GET_MEMBERINFO()
    this.profile = this.getLiffProfile()
    await this.getBlog()
  },
  methods: {
    ...mapGetters('lineStore', ['liffIsReady', 'getLiffProfile']),
    ...mapGetters('memberStore', ['GET_MEMBERINFO']),

    async getBlog () {
      const result = await this.callBeTaskAPI(
        'get',
        `/blog/get?RECORD_STATUS=N&shopId=${this.session.shopId}`
      )
      if (Array.isArray(result)) {
        this.items = result
      }
    },
    checkLinkOrBlog (item) {
      // @click="$router.push(`/blog/detail/${item.id}`)"
      item.output === 'เว็บไซต์' ? window.location.href = item.blogLink : this.$router.push(`/blog/detail/${item.id}`)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/AllBlog.vue